var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _vm.allowSearch
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12 mb-2" }, [
              _c("div", { staticClass: "input-group mb-1" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.searchText,
                      expression: "searchText",
                    },
                  ],
                  ref: "fldSearchText",
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    placeholder: "Filter Using Search Terms Here...",
                  },
                  domProps: { value: _vm.searchText },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.searchText = $event.target.value
                    },
                  },
                }),
                _vm._v(" "),
                _vm.categories && _vm.categories.length
                  ? _c(
                      "div",
                      { staticClass: "input-group-append d-print-none" },
                      [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.category,
                                expression: "category",
                              },
                            ],
                            staticClass: "form-control",
                            attrs: {
                              placeholder: "Filter Using Categories Here....",
                            },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.category = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          [
                            _c("option"),
                            _vm._v(" "),
                            _vm._l(_vm.categories, function (category) {
                              return _c(
                                "option",
                                {
                                  key: category.value,
                                  domProps: { value: category.value },
                                },
                                [_vm._v(_vm._s(category.text))]
                              )
                            }),
                          ],
                          2
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "input-group-append d-print-none d-none d-md-block",
                  },
                  [
                    _c("generic-toggle", {
                      attrs: { label: "Detail Mode" },
                      model: {
                        value: _vm.detailMode,
                        callback: function ($$v) {
                          _vm.detailMode = $$v
                        },
                        expression: "detailMode",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-tabs",
        {
          model: {
            value: _vm.tabsIndex,
            callback: function ($$v) {
              _vm.tabsIndex = $$v
            },
            expression: "tabsIndex",
          },
        },
        _vm._l(_vm.moduleTabs, function (moduleTab) {
          return _c(
            "b-tab",
            {
              key: moduleTab.title,
              staticClass: "mt-1",
              attrs: { title: moduleTab.title, active: moduleTab.isActive },
            },
            [
              !_vm.detailMode
                ? _c(
                    "div",
                    { staticClass: "row" },
                    _vm._l(moduleTab.modules, function (module) {
                      return _c(
                        "div",
                        { key: module.id, staticClass: "col-md-3 col-lg-2" },
                        [
                          _c(
                            "div",
                            { staticClass: "card app-home-card" },
                            [
                              module.to
                                ? _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: module.to,
                                        title: module.description,
                                      },
                                    },
                                    [
                                      _c("a", [
                                        _c(
                                          "div",
                                          { staticClass: "card-img-top" },
                                          [
                                            _c("i", {
                                              staticClass: "fas",
                                              class: module.icon,
                                            }),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "card-body" },
                                          [
                                            _vm.isHome
                                              ? _c(
                                                  "h5",
                                                  {
                                                    staticClass:
                                                      "card-title text-center",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(module.moduleTitle)
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "h5",
                                              {
                                                staticClass:
                                                  "card-title text-center",
                                              },
                                              [_vm._v(_vm._s(module.title))]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              module.href
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: module.href,
                                        title: module.description,
                                        target: module.target,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "card-img-top" },
                                        [
                                          _c("i", {
                                            staticClass: "fas",
                                            class: module.icon,
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "card-body" }, [
                                        _vm.isHome
                                          ? _c(
                                              "h5",
                                              {
                                                staticClass:
                                                  "card-title text-center",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(module.moduleTitle)
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "h5",
                                          {
                                            staticClass:
                                              "card-title text-center",
                                          },
                                          [_vm._v(_vm._s(module.title))]
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !module.isModule && !module.isLink
                                ? _c("div", { staticClass: "card-footer" }, [
                                    !module.isLink &&
                                    !module.isModule &&
                                    !module.isFavorite
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-success btn-sm",
                                            attrs: {
                                              type: "button",
                                              title: "Add Favorite",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.addFavorite(
                                                  module.code,
                                                  $event
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fas fa-heart",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !module.isLink &&
                                    !module.isModule &&
                                    module.isFavorite
                                      ? _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-danger btn-sm",
                                            attrs: {
                                              type: "button",
                                              title: "Remove Favorite",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeFavorite(
                                                  module.code,
                                                  $event
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fas fa-trash",
                                            }),
                                          ]
                                        )
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.detailMode
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-12" },
                      [
                        _c("generic-table", {
                          attrs: {
                            items: moduleTab.modules,
                            fields: moduleTab.fields,
                            "hide-toolbar": "",
                            "hide-pagination": "",
                            "force-raw-table-mode": "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(actions)",
                                fn: function (data) {
                                  return [
                                    _c("div", { staticClass: "form-row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-lg-6 mx-0 pl-0 pr-0 pr-lg-1",
                                        },
                                        [
                                          data.item.to
                                            ? _c(
                                                "router-link",
                                                { attrs: { to: data.item.to } },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "btn btn-sm btn-primary btn-block px-1",
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass: "fas",
                                                        class: data.item.icon,
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          data.item.href
                                            ? _c(
                                                "a",
                                                {
                                                  staticClass:
                                                    "btn btn-sm btn-primary btn-block px-1",
                                                  attrs: {
                                                    href: data.item.href,
                                                    target: data.item.target,
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fas",
                                                    class: data.item.icon,
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "col-lg-6 mx-0 px-0" },
                                        [
                                          !data.item.isLink &&
                                          !data.item.isModule &&
                                          !data.item.isFavorite
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-success btn-sm btn-block",
                                                  attrs: {
                                                    type: "button",
                                                    title: "Add Favorite",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.addFavorite(
                                                        data.item.code,
                                                        $event
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fas fa-heart",
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !data.item.isLink &&
                                          !data.item.isModule &&
                                          data.item.isFavorite
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-danger btn-sm btn-block",
                                                  attrs: {
                                                    type: "button",
                                                    title: "Remove Favorite",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.removeFavorite(
                                                        data.item.code,
                                                        $event
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "fas fa-trash",
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }